<template>
    <div class="wrap-breadcrumb">
        <ul itemscope vocab="http://schema.org/" typeof="BreadcrumbList">
            <li v-for="(page, index) in pages" :key="index" class="item-link" itemscope property="itemListElement" typeof="ListItem">
                <a v-if="page.link" :id="page.link" :href="page.link" :alt="page.name" :title="page.name" v-bind:class="page.name == 'Home' ? 'fa fa-home' : 'link'" property="item" typeof="WebPage"
                   itemprop="item">
                    <span :alt="page.name" :title="page.name" property="name" itemprop="item"><span v-if="page.name != 'Home'">{{ page.name }}</span></span>
                </a>
                <span v-else :alt="page.name" :title="page.name" property="name" itemprop="item"><span v-if="page.name != 'Home'">{{ page.name }}</span></span>
                <meta property="position" :content="index + 1">
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        name: 'Breadcrumb',
        props: [
            'pages'
        ]
    }
</script>
